import React from 'react';
import { Box, Container, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { HomeH2 } from '@bizapp-lp/workflow/molecules/Heading';
import { QuestionAccordion } from '@bizapp-lp/workflow/molecules/Question';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#F2F3FB 0% 0% no-repeat padding-box',
      padding: theme.spacing(7, 2, 9),
      [theme.breakpoints.up('tablet')]: { padding: theme.spacing(7, 4, 9) },
      [theme.breakpoints.up('tabletEx')]: { padding: theme.spacing(7, 10, 9) },
    },
    sectionHeading: {
      margin: '0 auto',
    },
    questionItem: {
      boxSizing: 'border-box',
      margin: '64px auto 0',

      '& > *': {
        margin: theme.spacing(3, 'auto', 0),
        maxWidth: '640px',
        [theme.breakpoints.up('tabletEx')]: { maxWidth: '1206px' },
      },
      '& .MuiListItem-root': {
        listStyle: 'disc',
        display: 'list-item',
        marginLeft: '1.8rem',
        padding: 0,
        marginBottom: '20px',
      },
    },
  }),
);

export interface QuestionProps {
  id: string;
  question: string;
  answer: React.ReactNode;
}

export interface FAQProps {
  className?: string;
  questions?: QuestionProps[];
}

export const FAQ: React.FC<FAQProps> = React.memo(
  ({ className, questions }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState<string>('none');

    const handleChange = React.useCallback(
      (panel: string) => (
        event: React.ChangeEvent<{}>,
        isExpanded: boolean,
      ) => {
        setExpanded(isExpanded ? panel : 'none');
      },
      [],
    );

    return (
      <Container
        component="section"
        disableGutters
        maxWidth={false}
        className={`${classes.root} ${className ?? ''}`}
      >
        <HomeH2 variant="themeColor" className={classes.sectionHeading}>
          <em>よくあるご質問</em>
        </HomeH2>

        <Box className={classes.questionItem}>
          {questions &&
            Array.from(questions.values()).map((v) => {
              const { id, question, answer } = v;
              return (
                <QuestionAccordion
                  id={id}
                  question={question}
                  expanded={expanded === id}
                  onChange={handleChange(id)}
                  children={answer}
                  key={id}
                />
              );
            })}
        </Box>
      </Container>
    );
  },
);
